import { Link } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { api } from '../../lib/api'
import type { ReportListItem } from '../../types'
import { Alert, Card, CardBody, Skeleton } from '../../components/ui'
import { AlertIcon, ChartIcon, DocIcon, IdIcon, ShieldIcon } from '../../components/icons'

const ICONS: Record<string, React.ComponentType<{ size?: number }>> = {
  factory: ChartIcon, send: IdIcon, receipt_long: DocIcon,
  local_shipping: IdIcon, warning_amber: AlertIcon, flag: AlertIcon, map: ShieldIcon,
}

export default function Reports() {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: ['leader', 'reports'],
    queryFn: () => api.get<{ ok: boolean; items: ReportListItem[] }>('/leader/reports'),
  })

  const items = data?.items ?? []
  const groups = [...new Set(items.map((i) => i.group))]

  return (
    <>
      <div className="page-head">
        <div>
          <h1>Reports</h1>
          <p className="page-head__sub">Operational and compliance reports for your cooperative.</p>
        </div>
      </div>

      {isError ? (
        <Alert tone="danger">{(error as Error).message}</Alert>
      ) : isLoading ? (
        <div className="grid grid--2"><Skeleton h={80} /><Skeleton h={80} /></div>
      ) : (
        groups.map((group) => (
          <div key={group} style={{ marginBottom: 'var(--sp-6)' }}>
            <h3 style={{ margin: '0 0 var(--sp-3)' }}>{group}</h3>
            <div className="grid grid--2">
              {items.filter((i) => i.group === group).map((r) => {
                const Icon = ICONS[r.icon ?? ''] ?? DocIcon
                return (
                  <Link key={r.id} to={`/reports/${r.id}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                    <Card hover>
                      <CardBody>
                        <div className="row" style={{ gap: 'var(--sp-3)', alignItems: 'center' }}>
                          <Icon size={20} />
                          <span style={{ fontWeight: 600 }}>{r.title}</span>
                        </div>
                      </CardBody>
                    </Card>
                  </Link>
                )
              })}
            </div>
          </div>
        ))
      )}
    </>
  )
}
